// Send email with For Sale pdf
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		const sign     = document.getElementById("fsSign");
		const down     = document.getElementById("fsDown");
		const send     = document.getElementById("sendPDF");
		const popup    = document.getElementById("popUp");
		const form     = document.getElementsByTagName("form")[0];
		const emailInp = document.getElementById("fsEmail");
		const message  = document.getElementById("fsMessage");

		//Show email form
		if (sign) {
			sign.addEventListener("click", function () {
				popup.classList.add("block");
				form.style.display = "block";
				message.style.display = "none";
				emailInp.setAttribute("required", "required");
				document.querySelector(".container.forms").style.display = "block";

				if(!emailInp.value || emailInp.value == "") SendData.btnDisable(send);

				setTimeout(() => {
					popup.scrollIntoView({block: "start", behavior: "smooth"});
				}, 100);
			});
		}
		
		//validate email
		if (emailInp) {
			emailInp.addEventListener("input", function () {
				SendData.validateEmail(this);
			});
		}

		// Download PDF
		if (down) {
			down.addEventListener("click", function (event) {
				event = event || window.event;
				event.preventDefault();

				this.form.querySelector("input[name='price']").value = document.getElementById("price").value;
				this.form.submit();
			});
		}
		
		//Send data to server
		if (send) {
			send.addEventListener("click", function (event) {
				event = event || window.event;
				event.preventDefault();

				SendData.validateEmail(emailInp);

				let dataJSON = JSON.stringify({
					_token      : document.querySelector("input[name='_token']").value,
					email       : emailInp.value,
					item        : document.getElementById("fsID") ? document.getElementById("fsID").innerText : "",
					price       : document.getElementById("price") ? document.getElementById("price").value : "",
					details     : document.querySelector('textarea#detailsPdfText') ? document.querySelector('textarea#detailsPdfText').value : "",
					fontsize    : document.getElementById("vehicle-input") ? document.getElementById("vehicle-input").value : "",
                    submitbutton: event.target.value
				});

				let url = this.form.action || "/";

				if (this.dataset.disabled=== "false") {
					SendData.sendAJAX(dataJSON, url, "POST");

					this.parentElement.parentElement.appendChild(Preloader(true));
					
					this.parentElement.style.display = "none";
				} else {
					SendData.inputErr("err");
				}
			});
		}

		// Create data for request
		

		// Send Sor Sale - module
		var SendData = {
			sendAJAX(data, url, method) {
				let xhr = new XMLHttpRequest();
				let postHead = "application/json; charset=utf-8";
				const csrfToken = document.querySelector("meta[name='csrf-token']");

				/* console.log('------------------------------------');
				console.log(data);
				console.log('------------------------------------'); */

				if(method === "POST") {
					xhr.open("POST", url, true);
					xhr.setRequestHeader("Content-type", postHead);
					xhr.send(data);
				} else {
					xhr.open("GET", url, true);
					xhr.send();
				}

				xhr.onreadystatechange = function() {
					if (this.readyState != 4) {
						Preloader(false);
						SendData.message("success");
						return;
					}

					if (this.status != 200) {
						console.error( "Error: " + (this.status ? this.statusText : "query failed") );
						Preloader(false);
						SendData.message("error");
						return;
					}
				};
			},

			validateEmail(input) {
				let email    = input.value;
				let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

				if(regEmail.test(email)) {
					SendData.inputErr("valid");
				} else {
					SendData.inputErr("err");
				}
			},

			btnDisable(btn) {
				btn.disabled = true;
				btn.dataset.disabled = "true";
				btn.classList.add("disabled");
			},

			btnEnable(btn) {
				btn.disabled = false;
				btn.dataset.disabled = "false";
				btn.classList.remove("disabled");			
			},

			inputErr(type) {
				let classErr = "empty-field";
				let emailErr = document.getElementById("fsEmailError");

				switch (type) {
					case "err":
						emailErr.style.display = "block";
						emailInp.classList.add(classErr);
						SendData.btnDisable(send);
						break;
					case "valid":
						emailErr.style.display = "none";
						emailInp.classList.remove(classErr);
						SendData.btnEnable(send);
						break;
				}
			},

			message(type) {
				//success
				let successClass = "success";
				let successMessage = `<i class="fa fa-check-circle"></i> Thank you, the sign has been emailed to you just now!`;
				//error
				let errorClass = "error";
				let errorMessage = `<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Your For Sale sign has not been sent.`;

				form.style.display = "none";
				message.style.display = "block";

				switch (type) {
					case "success":
						message.classList.add(successClass);
						message.classList.remove(errorClass);
						message.innerHTML = successMessage;
						break;
					case "error":
						message.classList.add(errorClass);
						message.classList.remove(successClass);
						message.innerHTML = errorMessage;
						break;
				}
			}
		};

		// Preloader
		function Preloader(flag) {
			var preloaderID = "smallPreloader";
			var preloader;
			var preloaderClass = "preloader";
			var preloaderDot = `<span class="preloader__dot"></span>`;

			// crete or search element
			if(document.getElementById(preloaderID)) preloader = document.getElementById(preloaderID);
			else {
				preloader = document.createElement("div");
				preloader.id = preloaderID;
				preloader.classList.add(preloaderClass);
				
				for (let i = 0; i < 3; i++) {
					preloader.innerHTML += preloaderDot;					
				}
			}

			// return or delete element
			if(flag) return preloader;
			else {
				preloader.parentElement ? preloader.parentElement.removeChild(preloader) : "";
				preloader = null;
			}
		}
	});
})();